type NullableNumeric = number | string | null | undefined;

export const limitDecimals = (
  value: NullableNumeric,
  digits: number = 2
): number => {
  if (value === null || value === undefined) return 0;

  const parsed =
    typeof value === 'number'
      ? value
      : (() => {
          const normalized = value.trim().replace(',', '.');
          const num = Number(normalized);
          return num;
        })();

  if (!Number.isFinite(parsed)) return 0;

  const safeDigits = Number.isFinite(digits)
    ? Math.max(0, Math.floor(digits))
    : 2;

  const fixed = parsed.toFixed(safeDigits);

  const trimmed = fixed.replace(/(?:\.0+|(\.\d+?)0+)$/, '$1');

  return Number(trimmed);
};
